import { BrowserRouter } from 'react-router-dom'
import Rotas from './routes'
import AuthProvider from './contexts/auth'
import SimulationProvider from './contexts/simulation'
import InvestimentosnProvider from './contexts/investimento'
import DebitosProvider from './contexts/debitos'
import DividendosProvider from './contexts/dividendos'
import LoadingProvider from './contexts/LoadingContext'
import { CurrencyProvider } from './contexts/Currency'
import { Toaster } from 'sonner';

function App() {
  return (
    <LoadingProvider>
      <AuthProvider>
        <CurrencyProvider>
          <SimulationProvider>
            <InvestimentosnProvider>
              <DebitosProvider>
                <DividendosProvider>
                  <BrowserRouter>
                    <Toaster
                      position="top-right"
                      richColors
                      expand={false}
                      closeButton
                    />
                    <Rotas />
                  </BrowserRouter>
                </DividendosProvider>
              </DebitosProvider>
            </InvestimentosnProvider>
          </SimulationProvider>
        </CurrencyProvider>
      </AuthProvider>
    </LoadingProvider>
  );
}

export default App;
